module.exports = __webpack_public_path__ + "static/media/gallery5.2410c7ed.png";